import { render, staticRenderFns } from "./CardSwipper.vue?vue&type=template&id=12a0910e&scoped=true&"
import script from "./CardSwipper.vue?vue&type=script&lang=js&"
export * from "./CardSwipper.vue?vue&type=script&lang=js&"
import style0 from "./CardSwipper.vue?vue&type=style&index=0&id=12a0910e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0910e",
  null
  
)

export default component.exports